<template>
  <div>
    <el-select
      v-model="curTempId"
      :disabled="disabled"
      class="tips-temp"
      placeholder=""
      filterable
      @change="handleTipsTempChange"
    >
      <el-option v-for="item in spaceTempList" :key="item.tempId" :value="item.tempId" :label="item.tempName"></el-option>
    </el-select>
    <el-button type="text" :icon="disabled ? 'el-icon-view' : 'el-icon-edit'" @click="openEdit">{{ disabled ? '查看' : '编辑' }}</el-button>
    <el-button v-if="!disabled" type="text" icon="el-icon-delete" @click="handleClear">清空</el-button>
    <!-- 编辑查看提示语弹窗 -->
    <el-dialog :visible.sync="showDialog" top="5vh" width="80%" title="广告提示语配置">
      <el-form ref="form" :model="form" label-width="80px" label-position="left">
        <el-row class="header-box">
          <el-form-item label="套用模板" label-width="100px">
            <el-select
              v-model="form.tempId"
              :disabled="disabled"
              class="tips-temp"
              placeholder=""
              filterable
              @change="formTipsChange"
            >
              <el-option v-for="item in spaceTempList" :key="item.tempId" :value="item.tempId" :label="item.tempName"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row :gutter="20" style="margin-bottom:0">
          <el-col :span="6">
            <el-card shadow="never" class="body-left">
              <div slot="header" class="clearfix">
                <span>提示语列表</span>
                <div style="float: right;">
                  <el-button :disabled="disabled" type="text" @click="addTips">增加</el-button>
                  <el-button :disabled="disabled" type="text" @click="deleteTips">删除</el-button>
                </div>
              </div>
              <div class="tips-list">
                <div
                  v-for="(item, index) in form.detailList"
                  :key="index"
                  :class="['tips-item', index === tipsIndex ? 'active' : '']"
                  @click="tipsIndex = index"
                >
                  <span :title="item.content">{{ item.content }}</span>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="18">
            <el-card header="提示语参数" shadow="never">
              <template v-if="form.detailList.length > 0">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="场景">
                      <el-select v-model="curTips.screenType" :disabled="disabled" @change="setCustomTemp">
                        <el-option value="full" label="全屏"></el-option>
                        <el-option value="mini" label="小屏"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="开始时间"
                      :prop="'detailList.' + tipsIndex + '.showTime'"
                      :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                    >
                      <el-input-number
                        v-model="curTips.showTime"
                        :min="-1"
                        :max="curTips.endTime"
                        :step="1"
                        :disabled="disabled"
                        controls-position="right"
                        @change="setCustomTemp"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="结束时间"
                      :prop="'detailList.' + tipsIndex + '.endTime'"
                      :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                    >
                      <el-input-number
                        v-model="curTips.endTime"
                        :min="curTips.showTime"
                        :step="1"
                        :disabled="disabled"
                        controls-position="right"
                        @change="setCustomTemp"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="位置">
                      <el-select v-model="curTips.locationType" :disabled="disabled" filterable @change="setCustomTemp">
                        <el-option :value="1" label="上左"></el-option>
                        <el-option :value="2" label="上中"></el-option>
                        <el-option :value="3" label="上右"></el-option>
                        <el-option :value="4" label="中左"></el-option>
                        <el-option :value="5" label="居中"></el-option>
                        <el-option :value="6" label="中右"></el-option>
                        <el-option :value="7" label="下左"></el-option>
                        <el-option :value="8" label="下中"></el-option>
                        <el-option :value="9" label="下右"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="上下边距"
                      :prop="'detailList.' + tipsIndex + '.marginY'"
                      :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                    >
                      <el-input-number
                        v-model="curTips.marginY"
                        :min="0"
                        :step="1"
                        :disabled="disabled"
                        controls-position="right"
                        @change="setCustomTemp"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="左右边距"
                      :prop="'detailList.' + tipsIndex + '.marginX'"
                      :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                    >
                      <el-input-number
                        v-model="curTips.marginX"
                        :min="0"
                        :step="1"
                        :disabled="disabled"
                        controls-position="right"
                        @change="setCustomTemp"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="类型">
                      <el-select v-model="curTips.type" :disabled="disabled" filterable @change="changeTipsType">
                        <el-option value="txt" label="文字"></el-option>
                        <el-option value="image" label="图片"></el-option>
                        <el-option value="qrcode" label="二维码"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <template v-if="curTips.type === 'txt'">
                    <el-col :span="8">
                      <el-form-item label="展示样式">
                        <el-select v-model="curTips.textStyle" :disabled="disabled" filterable @change="setCustomTemp">
                          <el-option :value="1" label="文字阴影"></el-option>
                          <el-option :value="2" label="文字加背景色"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="字号">
                        <el-select v-model="curTips.fontSize" :disabled="disabled" filterable @change="setCustomTemp">
                          <el-option v-for="item in fontSizeOptions" :key="item" :value="item" :label="item"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </template>
                  <template v-else>
                    <el-col :span="8">
                      <el-form-item
                        label="宽度"
                        :prop="'detailList.' + tipsIndex + '.width'"
                        :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                      >
                        <el-input-number
                          v-model="curTips.width"
                          :min="0"
                          :step="1"
                          :disabled="disabled"
                          controls-position="right"
                          @change="setCustomTemp"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="高度"
                        :prop="'detailList.' + tipsIndex + '.height'"
                        :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                      >
                        <el-input-number
                          v-model="curTips.height"
                          :min="0"
                          :step="1"
                          :disabled="disabled"
                          controls-position="right"
                          @change="setCustomTemp"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                  </template>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item
                      label="文案"
                      :prop="'detailList.' + tipsIndex + '.content'"
                      :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                    >
                      <el-input v-model.trim="curTips.content" :disabled="disabled" @change="setCustomTemp"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="!disabled" slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="saveAdTips">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    spaceId: { type: Number },
    tipsTempId: { type: Number },
    tipsDetail: { type: String }
  },
  data() {
    return {
      spaceTempList: [],
      curTempId: undefined,
      form: {
        tempId: undefined,
        detailList: []
      },
      tipsIndex: 0,
      showDialog: false,
      fontSizeOptions: [12, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 48]
    }
  },
  computed: {
    curTips() {
      return this.form.detailList[this.tipsIndex]
    }
  },
  watch: {
    spaceId: {
      handler(val) {
        this.getTipsTempList()
      }
    },
    tipsTempId: {
      handler(val) {
        this.curTempId = val
      }
    }
  },
  created() {
    this.getTipsTempList().then(res => {
      if (this.tipsTempId !== undefined) {
        this.curTempId = this.tipsTempId
        this.form.tempId = this.tipsTempId
        this.form.detailList = this.tipsDetail ? JSON.parse(this.tipsDetail) : []
      }
    })
  },
  methods: {
    // 获取提示语模板
    getTipsTempList() {
      const customTemp = {
        tempId: -1,
        tempName: '自定义'
      }
      if (this.spaceId) {
        this.spaceTempList = [customTemp]
      } else {
        return
      }
      return this.$service.getAdTempTips({ spaceId: this.spaceId, adTip: 1 }).then((res) => {
        this.spaceTempList = res || []
        this.spaceTempList.unshift(customTemp)
      })
    },
    // 打开编辑
    openEdit() {
      if (this.curTempId !== undefined) {
        const tipsTemp = this.tipsDetail ? JSON.parse(this.tipsDetail) : []
        this.form.tempId = this.curTempId
        this.form.detailList = tipsTemp
      } else {
        this.form.tempId = undefined
        this.form.detailList = []
      }
      this.tipsIndex = 0
      this.showDialog = true
    },
    // 清空
    handleClear() {
      const result = {
        tipsTempId: undefined,
        tipsDetail: ''
      }
      this.curTempId = undefined
      this.$emit('save', result)
    },
    handleTipsTempChange(val) {
      const tipsTemp = this.spaceTempList.find(item => item.tempId === val)
      if (!tipsTemp.tipsDetail || tipsTemp.tipsDetail.length === 0) {
        return
      }
      const result = {
        tipsTempId: val,
        tipsDetail: JSON.stringify(tipsTemp.tipsDetail)
      }
      this.$emit('save', result)
    },
    formTipsChange(val) {
      const tipsTemp = this.spaceTempList.find(item => item.tempId === val)
      this.form.detailList = tipsTemp.tipsDetail || []
      this.tipsIndex = 0
    },
    // 增加tips
    addTips() {
      this.form.detailList.push({
        screenType: 'full',
        showTime: 0,
        endTime: 0,
        locationType: 1,
        fontSize: 12,
        type: 'txt',
        content: '自定义',
        textStyle: 1,
        marginX: 0,
        marginY: 0,
        width: 0,
        height: 0
      })
      this.tipsIndex = this.form.detailList.length - 1
      this.setCustomTemp()
    },
    // 删除tips
    deleteTips() {
      if (this.form.detailList[this.tipsIndex]) {
        this.form.detailList.splice(this.tipsIndex, 1)
        this.tipsIndex = this.form.detailList.length > 0 ? this.form.detailList.length - 1 : 0
        this.setCustomTemp()
      }
    },
    changeTipsType(type) {
      if (type === 'txt') {
        this.curTips.width = 0
        this.curTips.height = 0
      } else {
        this.curTips.textStyle = 1
        this.curTips.fontSize = 12
      }
      this.setCustomTemp()
    },
    setCustomTemp() {
      this.form.tempId = -1
    },
    // 保存编辑后的提示语
    async saveAdTips() {
      if (this.form.detailList.length === 0) {
        return this.$message.error('请至少添加一条提示语')
      }
      const isValid = await this.$refs.form.validate().catch(() => {})
      if (!isValid) return

      const result = {
        tipsTempId: this.form.tempId,
        tipsDetail: JSON.stringify(this.form.detailList)
      }
      this.$emit('save', result)
      this.showDialog = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.tips-temp.el-select
  margin-right 20px
  min-width 400px
  width calc(100% - 200px)
.header-box
  margin-bottom 20px
  padding 20px
  border 1px solid #e9e9e9
  border-radius 4px
.tips-item
  padding 10px 20px
  border-bottom 1px solid #e9e9e9
  line-height 40px
  height 40px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
  cursor pointer
  &:hover
    background-color #fffaf3
    color #ff8b00
  &.active
    border-left 4px solid #ff8b00
    background-color #fffaf3
    color #ff8b00
.body-left >>>.el-card__body
  padding 0
>>>.el-dialog__body
  padding 20px
>>>.el-dialog__footer
  padding 10px 20px 30px
  .el-button
    width 80px
.el-card
  height 320px
  >>>.el-card__header
    padding 10px 20px
.el-row
  margin-bottom 20px
.el-input-number
  width 100%
.tips-list
  height 267px
  overflow-y auto
</style>
